module.exports = __webpack_public_path__ + "static/media/envelope.eb592deb.svg";